export const READ_ONLY_MESSAGE =
  'Цей розділ доступний для перегляду. Збереження змін ще не підключено.'

export class ReadOnlyError extends Error {}

export const readOnly = (): never => {
  throw new ReadOnlyError(READ_ONLY_MESSAGE)
}
